(function () {
  var css = document.createElement('style');
  css.textContent = '.wk-cd__price s{color:#9a93a8;font-weight:400;margin-right:6px;font-size:.85em}.wk-cd-save{display:inline-block;margin-top:6px;padding:3px 10px;border-radius:999px;background:#F476AD;color:#fff;font-size:12px;font-weight:700}.wk-cd-yousave{display:flex;justify-content:space-between;margin:0 0 8px;color:#F476AD;font-weight:700;font-size:14px}';
  document.head.appendChild(css);
  var cache = {}, busy = false, timer;
  function rs(c) { return 'Rs.' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function prod(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    return cache[h];
  }
  function run() {
    var cd = document.querySelector('.wk-cd');
    if (!cd || busy || !cd.querySelector('.wk-cd__item[data-line]:not([data-wk-save])')) return;
    busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      return Promise.all(cart.items.map(function (it) {
        return prod(it.handle).then(function (p) {
          var v = p && p.variants ? p.variants.filter(function (x) { return x.id === it.variant_id; })[0] : null;
          var full = Math.max(v && v.compare_at_price ? v.compare_at_price * it.quantity : 0, it.original_line_price);
          return { full: full, now: it.final_line_price, save: full - it.final_line_price };
        });
      })).then(function (lines) {
        var total = 0;
        lines.forEach(function (l, i) {
          var li = cd.querySelector('.wk-cd__item[data-line="' + (i + 1) + '"]');
          if (!li) return;
          li.setAttribute('data-wk-save', '1');
          if (l.save <= 0) return;
          total += l.save;
          var price = li.querySelector('.wk-cd__price');
          if (price) price.innerHTML = '<s>' + rs(l.full) + '</s>' + rs(l.now);
          var info = li.querySelector('.wk-cd__info');
          if (info && !info.querySelector('.wk-cd-save')) info.insertAdjacentHTML('beforeend', '<span class="wk-cd-save">Save ' + rs(l.save) + '</span>');
        });
        total += Math.max(0, cart.items_subtotal_price - cart.total_price);
        var old = cd.querySelector('.wk-cd-yousave'); if (old) old.remove();
        var tot = cd.querySelector('[data-cd-total]');
        var row = tot && tot.parentElement;
        if (row && total > 0) row.insertAdjacentHTML('beforebegin', '<div class="wk-cd-yousave"><span>You save</span><span>' + rs(total) + '</span></div>');
      });
    }).catch(function () {}).then(function () { busy = false; setTimeout(run, 50); });
  }
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(run, 120); })
    .observe(document.body, { childList: true, subtree: true });
})();